/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.membership.pricing.discounts.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.factory.notice',
  'acme.common.service.permissions'
])

.controller('MembershipPricingDiscountsController', ['$scope', '$state', '$uibModal', '$q', 'ApiService', 'HelpersService', 'NoticeFactory', 'PermissionsService', function($scope, $state, $uibModal, $q, ApiService, HelpersService, NoticeFactory, PermissionsService) {

    $scope.membershipPricingDiscounts = {

      model: [],

      isLoaded: false,

      membershipLevels: [],

      couponCategories: [],

      discounts: [],

      showModal: '',

      notice: new NoticeFactory(),

      init: function() {
        $scope.$emit('Application::contentTitleChange', {
          title: 'Membership Coupon Discounts',
          buttonRight: {
            permissions: 'MEMBERSHIP_LIFECYCLE_ACTION_DISCOUNT_CREATE',
            label: '+ Add Membership Discount',
            action: function() {
              $scope.membershipPricingDiscounts.addMembershipDiscount();
            }
          },
          buttonLeft: {
            label: 'Close',
            action: function() {
              $scope.membershipPricingDiscounts.close();
            }
          }

        });

        this.getMembershipDiscounts();
      },

      getMembershipDiscounts: function() {
        var props = HelpersService.getPaginator();
        if ($state.params.action) {
          props.lifecycleActions = [$state.params.action];
        }
        return ApiService.membership.lifecycle.discounts.list(props).then(this.success.init, this.error.init);
      },

      getDiscounts: function() {
        return ApiService.discounts.list('v2', HelpersService.getPaginator()).then(this.success.getDiscounts, this.error.getDiscounts);
      },

      getCouponCategories: function() {
        return ApiService.coupons.categories.list(HelpersService.getPaginator()).then(this.success.getCouponCategories, this.error.getCouponCategories);
      },

      getMembershipLevels: function(group) {

        var props = HelpersService.getPaginator();

        props.salesChannels = 'online';
        props.isPublished = '1';
        props.summarize = '1';
        if (group) {
          props.membershipLevelGroup = group;
        }

        ApiService.membership.categories.list(props).then(this.success.getMembershipLevels, this.error.getMembershipLevels);

      },

      hasMembershipCouponDiscounts: function() {
        return this.model && this.model.length;
      },

      findItem: function(itemId, list) {
        var i, ii,
            r = false;

        list = list || [];

        for (i=0, ii=list.length; i < ii; i++) {
          if (itemId === list[i].id) {
            r = {
              item: list[i],
              index: i
            };
            break;
          }
        }

        return r;
      },

      process: function(list) {
        var i, ii;

        for (i=0, ii=list.length; i < ii; i++) {
          if (list[i].membershipLevelInfo instanceof Array) {
            list[i].membershipLevelCount = list[i].membershipLevelInfo.length;
          }
        }

        return list;
      },

      processCouponCategories: function() {
        var i, ii,
            found;
        for (i=0, ii=this.model.length; i < ii; i++) {
          found = this.findItem(this.model[i].couponCategoryId, this.couponCategories);
          if (found) {
            this.model[i].couponCategory = found.item;
          }
        }
      },

      processDiscounts: function() {
        var i, ii,
          found;
        for (i=0, ii=this.model.length; i < ii; i++) {
          found = this.findItem(this.model[i].discountId, this.discounts);
          if (found) {
            this.model[i].discount = found.item;
          }
        }
      },

      showCoupons: function(couponCategoryId) {
        var self = $scope.membershipPricingDiscounts;

        self.showModal = $uibModal.open({
          templateUrl: 'views/application/views/templates/modals/showCouponsModal.tpl.html',
          size: 'md',
          controller: 'TemplatesShowCouponsModalController',
          resolve: {
            CouponCategoryListData: function() {
              return ApiService.coupons.getCouponsByCategory(couponCategoryId, HelpersService.getPaginator());
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.showModal.result.then(function() {
          // Do nothing
        }, function () {
          // Do nothing
        });
      },

      addMembershipDiscount: function() {
        $state.go('application.membership.pricing.discounts.create');
      },

      changeMembershipDiscount: function(membershipDiscount) {
        if (PermissionsService.check('MEMBERSHIP_LIFECYCLE_ACTION_DISCOUNT_UPDATE')) {
          $state.go('application.membership.pricing.discounts.edit', {id: membershipDiscount.id});
        }
      },

      removeMembershipCouponDiscount: function(item, index) {
        var self = $scope.membershipPricingDiscounts;

        self.showModal = $uibModal.open({
          templateUrl: 'views/application/views/membership/pricing/discounts/modals/showRemoveDiscountModal.tpl.html',
          size: 'md',
          controller: [ '$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {

            $scope.errors = [];

            $scope.model = [];

            $scope.init = function() {

            };

            $scope.done = function() {
              $scope.success();
            };

            $scope.cancel = function () {
              $uibModalInstance.dismiss('cancel');
            };

            $scope.success = function () {
              $uibModalInstance.close(true);
            };

            $scope.init();

          }]
        });

        // Invoked when modal completes with close(params)
        self.showModal.result.then(function() {
          var found = self.findItem(item.id, self.model);
          if (found) {
            self.model.splice(found.index, 1);
            ApiService.membership.lifecycle.discounts.remove(item.id).then(self.success.removeMembershipCouponDiscount, self.error.removeMembershipCouponDiscount);
          }
        }, function () {
          // Do nothing
        });
      },

      close: function() {
        $state.go('application.membership.rules.lifecycle');
      },

      save: function() {
        var promises = [];
        for (i=0, ii=this.model.length; i < ii; i++) {
          if (this.model[i].id) {
            //update
            promises.push(ApiService.membership.lifecycle.discounts.update(this.model[i]));
          } else {
            promises.push(ApiService.membership.lifecycle.discounts.create(this.model[i]));
          }
        }
        $q.all(promises).then(this.success.save, this.error.save);
      },

      success: {
        init: function(response) {
          var self = $scope.membershipPricingDiscounts;
          self.model = self.process(response.data.payload.list);
          self.isLoaded = true;
          self.getDiscounts();
          self.getCouponCategories();
          self.getMembershipLevels();
        },
        getDiscounts: function(response) {
          var self = $scope.membershipPricingDiscounts;
          self.discounts = response.data.payload.list;
          self.processDiscounts();
        },
        getCouponCategories: function(response) {
          var self = $scope.membershipPricingDiscounts;
          self.couponCategories = response.data.payload.list;
          self.processCouponCategories();
        },
        getMembershipLevels: function(response) {
          var self = $scope.membershipPricingDiscounts;
          self.membershipLevels = response.data.payload.list;
        },
        removeMembershipCouponDiscount: function(response) {},
        save: function(response) {
          $scope.membershipPricingDiscounts.getMembershipDiscounts();
        }
      },

      error: {
        init: function(response) {},
        getDiscounts: function(response) {},
        getMembershipLevels: function(response) {},
        removeMembershipCouponDiscount: function(response) {
          $scope.membershipPricingDiscounts.notice.showErrorMessages([{
            message: response.data.error
          }]);
        },
        save: function(response) {
          $scope.membershipPricingDiscounts.notice.showErrorMessages([{
            message: response.data.error
          }]);
        }
      }

    };

    $scope.membershipPricingDiscounts.init();

}]);